import { i18n } from '../../translation';
import './AvatarCardFilterOverview.scss';
import template from './AvatarCardFilterOverview.vhtml';

export default {
	name: 'AvatarCardFilterOverview',
	template: template,
	props: {
		endpoint: {
			type: String,
		},
		amount: {
			type: Number,
			default: -1,
		},
		btnLabel: {
			type: String,
			default: i18n.t('readMore'),
		},
	},
};
